<div class="flex flex-col flex-end text-xs w-full md:items-center md:flex-row md:gap-8 p-[16px]">
  <div>
    <span class="lausd-powered-logo"> Powered By&nbsp;<img src="/assets/qb-logo-dark.svg" alt="Colbi Technologies Inc." style="height: 1.5rem" /> </span>
  </div>
  <div>Copyright 2025&copy; by Colbi Technologies Inc.&trade;</div>
  <div>All Right Reserved</div>
  <div>Privacy Policy</div>
  <div>Release of liability</div>
  <div>Help</div>
</div>
